import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <section className="pp section">
      <div className="wrapper wrapper--small">
        <h1 className='wrapper__title h2'>Política de Privacidade</h1>
        <p className="caption">Última atualização: 20/01/2025</p>
        <p className='pp-intro'>Na Plover, estamos empenhados em proteger a sua privacidade e fornecer transparência sobre como tratamos os seus dados pessoais. Esta Política de Privacidade rege-se pelo REGULAMENTO (UE) 2016/679 DO PARLAMENTO EUROPEU E DO CONSELHO de 27 de abril de 2016 relativo à proteção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados (Regulamento Geral sobre a Proteção de Dados), e descreve os tipos de dados pessoais que recolhemos, como os utilizamos e os seus direitos em relação às suas informações. Todos os dados tratados pela Plover são considerados confidenciais, armazenados de forma segura e acessíveis apenas por pessoal autorizado.</p>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>1. Que dados pessoais recolhemos?</h2>
          <p>O acesso e navegação no Plover.pt não exigem necessariamente o fornecimento de dados pessoais. No entanto, certas funcionalidades, como o envio de um formulário de contacto ou a interação connosco nas redes sociais, podem requerer informações pessoais.</p>
          <p>Recolhemos os seguintes tipos de dados:</p>
          <ul>
            <li><strong>Submissões de formulário de contacto:</strong> Dados de identificação: Nome, email e restante informação cedida voluntáriamente.</li>
            <li><strong>Interações nas redes sociais:</strong> Comentários ou mensagens enviados através das nossas páginas oficiais no Facebook e Instagram, informação de localização.</li>
            <li><strong>Cookies:</strong> Podemos utilizar cookies para melhorar a sua experiência no nosso website e recolher dados sobre o desempenho do site, utilização e preferências dos utilizadores. Estas tecnologias podem incluir cookies de terceiros, como os da HubSpot. A falta de fornecimento de dados obrigatórios pode impedir-nos de responder aos seus pedidos ou fornecer determinados serviços.</li>
          </ul>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>2. Como utilizamos os seus dados?</h2>
          <p>Utilizamos os dados pessoais recolhidos para os seguintes fins:</p>
          <ul>
            <li><strong>Responder a pedidos:</strong> Responder a questões, comentários ou pedidos submetidos através do formulário de contacto ou das redes sociais.</li>
            <li><strong>Melhorar os nossos serviços:</strong> Aperfeiçoar as nossas ofertas com base no feedback e interações dos utilizadores.</li>
            <li><strong>Comunicações de marketing:</strong> Com o seu consentimento, podemos enviar newsletters ou mensagens promocionais. Pode cancelar a subscrição a qualquer momento.</li>
            <li><strong>Garantir conformidade:</strong> Cumprir obrigações legais, como os requisitos do RGPD.</li>
          </ul>
          <p>A Plover não vende, aluga ou partilha dados pessoais com terceiros para fins comerciais.</p>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>3. Cookies e tecnologias de rastreamento</h2>
          <p>Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo quando visita um website. São amplamente utilizados para melhorar a funcionalidade do website, analisar a utilização e fornecer experiências personalizadas.</p>
          <p>Tipos de cookies utilizados no Plover.pt:</p>
          <ul>
            <li><strong>Cookies essenciais:</strong> Necessários para funcionalidades básicas, como envio de formulários e navegação.</li>
            <li><strong>Cookies de desempenho:</strong> Recolhem informações sobre como os visitantes interagem com o nosso website, como páginas visitadas e tempo despendido em cada página.</li>
            <li><strong>Cookies de terceiros:</strong> Serviços como o HubSpot ou plugins de redes sociais podem definir cookies para rastrear interações ou fornecer análises.</li>
          </ul>
          <p>As suas escolhas em relação aos cookies:</p>
          <p>Pode gerir ou eliminar cookies através das definições do seu navegador. No entanto, desativar certos cookies pode afetar a funcionalidade do nosso website.</p>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>4. Os seus direitos ao abrigo do RGPD</h2>
          <p>De acordo com o RGPD, tem os seguintes direitos em relação aos seus dados pessoais:</p>
          <ul>
            <li><strong>Acesso:</strong> Solicitar uma cópia dos dados pessoais que mantemos sobre si.</li>
            <li><strong>Retificação:</strong> Solicitar correções a dados incorretos ou incompletos.</li>
            <li><strong>Apagamento:</strong> Solicitar a eliminação dos seus dados, desde que não existam fundamentos legais para a sua retenção.</li>
            <li><strong>Restrição:</strong> Solicitar limitações ao tratamento dos seus dados em determinadas condições.</li>
            <li><strong>Portabilidade:</strong> Receber os seus dados num formato estruturado, de uso comum e legível por máquina.</li>
            <li><strong>Oposição:</strong> Opor-se ao tratamento dos seus dados, particularmente para fins de marketing direto.</li>
          </ul>
          <p>Para exercer os seus direitos, contacte-nos através de: <a className='link-primary' href="mailto:privacy@plover.pt">privacy@plover.pt.</a> O prazo para resposta é de até 30 dias.</p>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>5. Partilha dos seus dados</h2>
          <p>Podemos partilhar os seus dados nas seguintes circunstâncias:</p>
          <ul>
            <li><strong>Provedores de serviços:</strong> Ferramentas de terceiros, como a HubSpot, para gerir formulários de contacto e comunicações.</li>
            <li><strong>Exigências legais:</strong> Quando necessário para cumprir obrigações legais ou responder a pedidos legítimos de autoridades.</li>
          </ul>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>6. Durante quanto tempo retemos os seus dados?</h2>
          <p>Reteremos os seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta política:</p>
          <ul>
            <li><strong>Submissões de formulário de contacto:</strong> Retidos por 12 meses após a última comunicação.</li>
            <li><strong>Interações nas redes sociais:</strong> Retidos enquanto as conversas estiverem ativas.</li>
          </ul>
          <p>Quando os dados deixarem de ser necessários, serão eliminados ou anonimizados, salvo se a lei exigir um período de retenção mais longo.</p>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>7. Medidas de segurança</h2>
          <p>Levamos a segurança dos seus dados pessoais muito a sério. As nossas medidas incluem:</p>
          <ul>
            <li>Sistemas de armazenamento seguro e acesso restrito.</li>
            <li>Revisões e atualizações periódicas dos protocolos de segurança.</li>
          </ul>
        </section>
        
        <section className='pp section'>
          <h2 className='wrapper__title h3'>8. Alterações a esta política de privacidade</h2>
          <p>Esta Política de Privacidade pode ser atualizada para refletir alterações nas regulamentações ou nos nossos serviços. As atualizações serão publicadas nesta página, com a data da última revisão.</p>
        </section>

        <section className='pp section'>
          <h2 className='wrapper__title h3'>9. Contacte-nos</h2>
          <p>Para questões ou preocupações sobre esta Política de Privacidade, ou para exercer os seus direitos, contacte-nos: <a className='link-primary' href="mailto:privacy@plover.pt">privacy@plover.pt.</a></p>
        </section>
     
      </div>
    </section>
  );
};

export default PrivacyPolicy;